var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"permission-tooltip"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip-content"},[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/images/info-circle.svg"),"alt":"icon-info"}}),_c('span',[_vm._v("No dispones de los permisos necesarios para realizar esta acción")])])
}]

export { render, staticRenderFns }